import { RefOptionsAction, RefOptionsState } from "../types";

export const initialState: RefOptionsState = {
  codes: [],
  cachedOptions: {},
  isLoadingCodes: false,
  loadingOptions: {},
  errors: {
    codes: null,
    options: {},
  },
};

export function refOptionsReducer(
  state: RefOptionsState,
  action: RefOptionsAction,
): RefOptionsState {
  switch (action.type) {
    case "SET_LOADING_CODES":
      return {
        ...state,
        isLoadingCodes: action.payload,
        errors: { ...state.errors, codes: null },
      };

    case "SET_CODES":
      return {
        ...state,
        codes: action.payload,
        isLoadingCodes: false,
        errors: { ...state.errors, codes: null },
      };

    case "SET_CODES_ERROR":
      return {
        ...state,
        isLoadingCodes: false,
        errors: { ...state.errors, codes: action.payload },
      };

    case "SET_LOADING_OPTIONS":
      return {
        ...state,
        loadingOptions: {
          ...state.loadingOptions,
          [action.payload.code]: action.payload.loading,
        },
        errors: {
          ...state.errors,
          options: {
            ...state.errors.options,
            [action.payload.code]: null,
          },
        },
      };

    case "SET_OPTIONS":
      return {
        ...state,
        cachedOptions: {
          ...state.cachedOptions,
          [action.payload.code]: action.payload.options,
        },
        loadingOptions: {
          ...state.loadingOptions,
          [action.payload.code]: false,
        },
        errors: {
          ...state.errors,
          options: {
            ...state.errors.options,
            [action.payload.code]: null,
          },
        },
      };

    case "SET_OPTIONS_ERROR":
      return {
        ...state,
        loadingOptions: {
          ...state.loadingOptions,
          [action.payload.code]: false,
        },
        errors: {
          ...state.errors,
          options: {
            ...state.errors.options,
            [action.payload.code]: action.payload.error,
          },
        },
      };

    case "CLEAR_CACHE":
      return {
        ...state,
        cachedOptions: {},
        loadingOptions: {},
        errors: { ...state.errors, options: {} },
      };

    default:
      return state;
  }
}
